//引入vue
import Vue from 'vue';
//引入vue-router
import Router from 'vue-router';
//第三方库需要use一下才能用
Vue.use(Router)
const originalPush = Router.prototype.push
   Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
const routes=[
    {
        path: '/',
        component: () => import('@/views/login'),
        meta: {
            title: '登录'
        }
    },
    {
        path: '/login',
        component: () => import('@/views/login'),
        meta: {
            title: '登录'
        }
    },
    {
        path: '/course',
        component: () => import('@/views/course'),
        meta: {
            title: '功能聚合页'
        }
    },
]

const router=new Router({
    routes
});

export default router